<template>
    <span class="nav-item my-2 my-lg-0">
        <!-- Current User -->
            <a class="mr-sm-2">
                <span 
                  style="margin-right: 3px;"
                  class="fa fa-user fa-lg d-none d-md-inline d-lg-inline" 
                  aria-hidden="true">
                </span>
                <b>{{auth.userName}}</b>
            </a>
        <!-- Logout-Button -->
            <a class="my-2 my-sm-0" v-bind:href="logoutUrl" id="logoutUrl">
                <span class="fa fa-sign-out fa-lg"  aria-hidden="true"></span>
                <span class="d-none d-md-inline d-lg-inline"> Logout</span>
            </a>
    </span>
</template>

<script>
import { mapState } from "vuex";
import { context } from "../../context";

export default {
  name: "nav-logout",
  data() {
    return {
      logoutUrl: context.logoutUrl
    };
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
};
</script>

<style scoped>
#logoutUrl {
  color: #ff2716;
}
#logoutUrl:hover {
  color: #990000;
}
</style>